import React, { useEffect, useState } from "react";
import { getAllUsers, deleteAccount } from "../../../apis/usersApi";
import { Table } from "antd";
import getUserColumns from "../../../const/Columns/getUserColumns";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await getAllUsers();
      setUsers(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Run filtering only when users or searchText change
  useEffect(() => {
    if (users?.length > 0) {
      const filtered = users?.filter(
        (user) =>
          user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredUsers(filtered);
    }
  }, [searchText, users]);

  const deleteAcc = async (body) => {
    setLoading(true);
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm("Are you sure you want to delete account?")
    ) {
      const res = await deleteAccount(body);
      console.log("results", res);
      if (res?.success) {
        fetchUsers();
      } else {
        alert(res?.message);
      }
    }
    setLoading(false);
  };

  const columns = getUserColumns(deleteAcc);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              {/* <Link to="/addUser" className="btn add-new btn-primary mb-3">
                Add User
              </Link> */}
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by name or email"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={
                    searchText !== "" && filteredUsers.length > 0
                      ? filteredUsers
                      : users?.length > 0
                        ? users
                        : []
                  }
                  className="table-striped"
                  rowKey={(record) => record.id}
                  // pagination={{ position: ["bottomCenter"] }}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
